export var ColorFormat;
(function (ColorFormat) {
    ColorFormat["Hex"] = "HEX";
    ColorFormat["Hsla"] = "HSLA";
    ColorFormat["Hsba"] = "HSBA";
    ColorFormat["Rgba"] = "RGBA";
})(ColorFormat || (ColorFormat = {}));
